class CTOHeader extends HTMLElement {
  constructor() {
    super();
    this.isMobile = false;
    this.isIntersecting = false;
    this.scrollPos = 0;
    this.onScroll = this.onScroll.bind(this);
  }

  connectedCallback() {
    this.addEvents();
    this.updateShareButtonUrlInCollectionView();
    window.updateShareButtonUrlInCollectionView = this.updateShareButtonUrlInCollectionView;
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
  }

  addEvents() {
    this.isMobile = window.matchMedia(
      "only screen and (max-width: 1023px)"
    ).matches;

    const $header = this;
    const $headerSticky = document.querySelector('.js-cto-header-sticky');
    const stickyHeight = $headerSticky.offsetHeight
    const opts = {
      root: null,
      rootMargin: `-${stickyHeight}px 0px 0px 0px`,
      threshold: 0
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.isIntersecting = true;
          $headerSticky.classList.remove('is-visible');
        } else {
          this.isIntersecting = false;
          $headerSticky.classList.add('is-visible');
        }

        this.scrollDirection();
      });
    }, opts);

    observer.observe($header);

    document.addEventListener('headerSticky', (e) => {
      const { isSticky } = e.detail;
      if (isSticky) {
        $headerSticky.classList.add('header-is-sticky');
      } else {
        $headerSticky.classList.remove('header-is-sticky');
      }
    });
  }

  updateShareButtonUrlInCollectionView() {
    if (window.ctoCollection) {
      const $shareButtons = document.querySelectorAll('share-button');
      $shareButtons.forEach(($shareButton) => {
        const $input = $shareButton.querySelector('input');
        if ($input) {
          $input.value = window.location.href;
        }
      });
    }
  }

  scrollDirection() {
    if (!this.isMobile) { return; }

    window.removeEventListener('scroll', this.onScroll);
    window.addEventListener('scroll', this.onScroll);
    this.onScroll();
  }

  onScroll() {
    const $headerSticky = document.querySelector('.js-cto-header-sticky');

    if (!$headerSticky) { return; }

    const currentScrollPos = document.body.getBoundingClientRect().top;
    const scrollUp = currentScrollPos > this.scrollPos;

    if (window.scrollY <= 0 || this.isIntersecting) {
      $headerSticky.classList.remove('is-visible');
    } else if (scrollUp) {
      $headerSticky.classList.add('is-visible');
    } else {
      $headerSticky.classList.remove('is-visible');
    }

    this.scrollPos = currentScrollPos;
  }
}

customElements.define('cto-header', CTOHeader);
